import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Flex, Loader } from 'nallian-shared-ui/lib/components';
import textService from '../services/textService';
import Markdown from '../../app/components/Markdown';

const OverviewText = ({ textFetch, name }) => {
  const { t } = useTranslation();

  return (
    <>
      {textFetch.pending ? (
        <Flex fluid justifyContent="center">
          <Loader active inline />
        </Flex>
      ) : (
        <>
          {textFetch.value?.contents ? (
            <Markdown markdown={textFetch.value.contents} />
          ) : (
            textFetch.rejected && (
              <>
                <p>{t('dear', { user: name })}</p>
                <p>{t('welcomeToTheCommunity')}</p>
                <p>{t('contactAdministrator')}</p>
              </>
            )
          )}
        </>
      )}
    </>
  );
};

OverviewText.propTypes = {
  name: PropTypes.string.isRequired,
  textFetch: PropTypes.object.isRequired,
};

export default textService(OverviewText);
